import { useState, useRef, useEffect } from "react";
import { useSingleton } from "../../hooks/use-singleton";
import { useApi } from "../../hooks/use-api";
import { API_GET_MCQ_TNPSC, API_MEDIUM_TNPSC } from "../../utils/api-routes";
import {
  API_MCQ_SUBJECTS,
  API_DESCRIPTIVE_MCQ_UPSC,
  API_DESCRIPTIVE_EXAM_UPSC,
  API_DESCRIPTIVE_YEAR_UPSC,
  API_DESCRIPTIVE_MEDIUM_UPSC,
  API_DESCRIPTIVE_SUBJECT_UPSC,
  API_DESCRIPTIVE_QUEST_TYPE_UPSC,
  API_DESCRIPTIVE_MARK_UPSC,
  API_DESCRIPTIVE_TOPIC_UPSC,
  API_DESCRIPTIVE_EVALUATE_UPSC,
} from "../../utils/api-routes";
import { apiStudentStudys } from "../../utils/api-routes";
import { useSearchParams } from "react-router-dom";

export const useHandler = () => {
  const { user, mail, medium, section } = useSingleton();
  const { get, post } = useApi();
  const [searchParams] = useSearchParams();
  const subject = searchParams.get("subject");
  const [openDropdown, setOpenDropdown] = useState(null);
  const [answers, setAnswers] = useState({});
  const [selectedSubject, setSelectedSubject] = useState(
    subject ? subject : "",
  );
  const [subjects, setSubjects] = useState([]);
  const [topics, setTopics] = useState([]);
  const [marks, setMarks] = useState([]);
  const [questionType, setQuestionType] = useState([]);
  const [selectedExam, setSelectedExam] = useState("UPSC");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMedium, setSelectedMedium] = useState("");
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [selectedMarks, setSelectedMarks] = useState("");
  const [questionDistribution, setQuestionDistribution] = useState({});
  const [questions, setQuestions] = useState([]);
  const [exams, setExams] = useState([]);
  const [years, setYears] = useState([]);
  const [mediums, setMediums] = useState([]);
  const [questionDetails, setQuestionDetails] = useState([]);
  const [markDetails, setMarkDetails] = useState({});

  const [showMarks, setShowMarks] = useState(false);
  const [isQuizActive, setIsQuizActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dropdownWrapperRef = useRef(null);

  const [currentQIndex, setCurrentQIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [classdetails, setClassDetails] = useState({});

  const mediumRef = useRef(null);
  const examRef = useRef(null);
  const yearRef = useRef(null);

  const subjectRef = useRef(null);

  const [panelOpen, setPanelOpen] = useState(true); // Start open

  const isStartEnabled =
    !!selectedMedium &&
    !!selectedSubject &&
    selectedTopics.length > 0 &&
    !!selectedMarks &&
    Object.keys(questionDistribution).length > 0;

  useEffect(() => {
    const fetchExams = async () => {
      setIsLoading(true);
      try {
        const res = await post(API_DESCRIPTIVE_EXAM_UPSC, {});
        if (res) setExams(res?.data?.exams || []);
      } catch (e) {
        console.error("Error loading exams", e);
      } finally {
        setIsLoading(false);
      }
    };
    fetchExams();
  }, []);

  useEffect(() => {
    if (!selectedExam) {
      setYears([]);
      setSelectedYear("");
      return;
    }
    const fetchYears = async () => {
      setIsLoading(true);
      setSelectedYear("");
      setSelectedMedium("");
      try {
        const res = await post(API_DESCRIPTIVE_YEAR_UPSC, {
          exam: selectedExam,
        });
        if (res) setYears(res?.data?.year || []);
      } catch (e) {
        console.error("Error loading years", e);
      } finally {
        setIsLoading(false);
      }
    };
    fetchYears();
  }, [selectedExam]);

  useEffect(() => {
    if (!selectedExam || !selectedYear) {
      setMediums([]);
      setSelectedMedium("");
      return;
    }
    const fetchMediums = async () => {
      setIsLoading(true);
      setSelectedMedium("");
      try {
        const res = await post(API_DESCRIPTIVE_MEDIUM_UPSC, {
          exam: selectedExam,
          year: selectedYear,
        });
        if (res) setMediums(res?.data?.medium || []);
      } catch (e) {
        console.error("Error loading mediums", e);
      } finally {
        setIsLoading(false);
      }
    };
    fetchMediums();
  }, [selectedExam, selectedYear]);

  const getUserStudiesDetails = async () => {
    try {
      const res = await get(apiStudentStudys(mail));
      if (res) {
        setClassDetails(res?.data);
        const payload = {
          board: res?.data?.data?.board,
          clas: res?.data?.data?.class,
        };
        getMediumDetails(payload);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      console.log("Error on getting user studiesdetails", e);
    }
  };

  const getMediumDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_MEDIUM_TNPSC, payload);
      if (res) {
        setMediums(res?.data?.mediums);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getSubjectDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_DESCRIPTIVE_SUBJECT_UPSC, payload);
      if (res) {
        setSubjects(res?.data?.subject || []);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getTopicDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_DESCRIPTIVE_TOPIC_UPSC, payload);
      if (res) {
        setTopics(res?.data?.topic);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };
  const getMarkDetails = async (payload) => {
    console.log("Calling Marks API", payload);

    setIsLoading(true);
    try {
      const res = await post(API_DESCRIPTIVE_MARK_UPSC, payload);
      if (res) {
        setMarks(res?.data?.marks);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getQuestionTypeDetails = async (payload) => {
    setIsLoading(true);
    try {
      const res = await post(API_DESCRIPTIVE_QUEST_TYPE_UPSC, payload);
      if (res) {
        setQuestionType(res.data.question_type);
        setIsLoading(false);
      } else {
        alert(res?.message);
      }
    } catch (e) {
      setIsLoading(false);
      console.log("Error on getting Subject Details", e);
    }
  };

  const getMcqdetails = async () => {
    try {
      const payload = {
        mail,
        exam: selectedExam,
        year: selectedYear,
        medium: selectedMedium,
      };
      const res = await post(API_GET_MCQ_TNPSC, payload);
      if (res) {
        setQuestionDetails(res?.data);
      }
    } catch (e) {
      console.log("getting error from get mcq details", e);
    }
  };

  useEffect(() => {
    getUserStudiesDetails();
  }, []);

  useEffect(() => {
    const questionTypes = Object.keys(questionDistribution);

    if (
      !selectedExam ||
      !selectedYear ||
      !selectedMedium ||
      !selectedSubject ||
      questionDistribution.length === 0
    ) {
      return;
    }

    questionTypes.forEach((type) => {
      getMarkDetails({
        exam: selectedExam,
        year: selectedYear,
        medium: selectedMedium,
        subject: selectedSubject,
        question_type: type,
      });
    });
  }, [
    selectedExam,
    selectedYear,
    selectedMedium,
    selectedSubject,
    questionDistribution,
  ]);

  useEffect(() => {
    const questionTypes = Object.keys(questionDistribution);
    if (
      !selectedExam ||
      !selectedYear ||
      !selectedMedium ||
      !selectedSubject ||
      questionDistribution.length === 0
    ) {
      return;
    }
    questionTypes.forEach((type) => {
      getTopicDetails({
        exam: selectedExam,
        year: selectedYear,
        medium: selectedMedium,
        subject: selectedSubject,
        question_type: type,
        marks: selectedMarks,
      });
    });
  }, [
    selectedExam,
    selectedYear,
    selectedMedium,
    selectedSubject,
    questionDistribution,
    selectedMarks,
  ]);

  useEffect(() => {
    if (!medium) return;
    const payload = {
      medium: selectedMedium,
      exam: selectedExam,
      year: selectedYear,
      subject: selectedSubject,
    };

    getQuestionTypeDetails(payload);
  }, [selectedSubject]);

  useEffect(() => {
    if (!medium) return;
    const payload = {
      medium: selectedMedium,
      exam: selectedExam,
      year: selectedYear,
    };

    getSubjectDetails(payload);
  }, [selectedExam, selectedMedium, selectedYear]);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!dropdownWrapperRef.current?.contains(e.target)) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownWrapperRef]);

  const onStartQuiz = async () => {
    try {
      setIsLoading(true);

      const payload = {
        exam: selectedExam,
        year: selectedYear,
        medium: selectedMedium,
        subject: selectedSubject,
        topics: selectedTopics,
        marks: Number(selectedMarks),
        question_distribution: questionDistribution,
      };

      console.log("Descriptive Payload:", payload);

      const response = await post(API_DESCRIPTIVE_MCQ_UPSC, payload);
      if (response) {
        setQuestions(response?.data?.questions || []);
        setIsQuizActive(true);
      }
      console.log("Descriptive Response:", response);
    } catch (error) {
      console.error("Descriptive API Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const questionPayload = {
    exam: selectedExam,
    year: selectedYear,
    medium: selectedMedium,
    subject: selectedSubject,
    topics: selectedTopics,
    marks: Number(selectedMarks),
    question_distribution: questionDistribution,
  };

  const normalizeQuestions = (apiData = []) =>
    apiData.map((q) => ({
      question: q["QUESTION"],
      options: [q["OPTION A"], q["OPTION B"], q["OPTION C"], q["OPTION D"]],
      answer: q["ANSWER"],
      questionId: q["QUESTION_ID"],
    }));

  const currentQuestion = questions[currentQIndex];

  useEffect(() => {
    if (questionDetails?.length) {
      const formatted = normalizeQuestions(questionDetails);
      setQuestions(formatted);
    }
  }, [questionDetails]);

  const handleOptionSelect = (index) => {
    // ❌ if already answered, don't allow change
    if (selectedAnswers[currentQIndex] !== undefined) return;
    setSelectedAnswers((prev) => ({
      ...prev,
      [currentQIndex]: index,
    }));
  };

  const selectedOption = selectedAnswers[currentQIndex];

  const handleNext = () => {
    if (currentQIndex < questions.length - 1) {
      setCurrentQIndex((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentQIndex > 0) {
      setCurrentQIndex((prev) => prev - 1);
    }
  };

  const buildSubmitPayload = () => {
    return questions
      .map((q, index) => {
        const selectedIndex = selectedAnswers[index];

        return {
          QUESTION: q.question,
          ANSWER: selectedIndex !== undefined ? q.options[selectedIndex] : "",
          QUESTION_ID: q.questionId || "",
        };
      })
      .filter(Boolean); // remove nulls
  };

  const handleUpscSubmit = async (typedAnswers) => {
    try {
      const payload = {
        mail,
        exam: selectedExam,
        subject: selectedSubject,
        medium: selectedMedium,

        questions: JSON.stringify(
          questions.map((q, index) => ({
            question_number: q.question_number,
            question: q.question,
            answer: typedAnswers[index] || "",
          })),
        ),

        // file: "",
      };

      console.log(payload);

      const res = await post(API_DESCRIPTIVE_EVALUATE_UPSC, payload);

      console.log(res);
    } catch (e) {
      console.log(e);
    }
  };

  return {
    user,
    mail,
    subjectRef,
    openDropdown,
    selectedSubject,
    handleUpscSubmit,
    setQuestionType,
    questionType,
    panelOpen,
    subjects,
    isStartEnabled,
    questionDetails,
    currentQuestion,
    selectedOption,
    questions,
    currentQIndex,
    markDetails,
    showMarks,
    setSelectedMarks,
    isQuizActive,
    isLoading,
    mediums,
    questionPayload,
    selectedMedium,
    mediumRef,
    section,
    setPanelOpen,
    setOpenDropdown,
    setSelectedSubject,
    onStartQuiz,
    handleNext,
    handlePrevious,
    handleOptionSelect,
    setIsQuizActive,
    setMediums,
    setSelectedMedium,
    dropdownWrapperRef,
    yearRef,
    selectedYear,
    years,
    setSelectedYear,
    selectedExam,
    mediumRef,
    setSelectedYear,
    questionType,
    questionDistribution,
    setQuestionDistribution,
    selectedTopics,
    setSelectedTopics,
    topics,
    marks,
    selectedMarks,
  };
};
